import 'Generic/styles/style.css';
import './styles/style.css';
import 'Generic/styles/products-info-modals-v2.css';
import 'Generic/styles/bfcm-conversion-driver-popup.css';
import 'Generic/styles/vpnAddonV2.css';
import 'Generic/styles/teamsAddons.css';
import 'Generic/styles/teamsVpnAddonV4.css';
import './styles/proPlan.css';
import './styles/checkout.css';
import 'Generic/styles/dedicated-popup.css';
import 'Generic/styles/resident-network-popup.css';
import {store, setState, fieldsValidation, GpayGateway, ApplePayGateway, constant} from 'Generic';
import PackageBoxes from './components/packageBoxes';
import Gateways from './components/gateways';
import Addons from './components/addons';
import VpnAddons from './components/vpnAddons';
import OrderSummary from './components/orderSummary';
import CheckoutForm from './components/checkoutForm';
import Incentive from './components/incentive';
import GatewayIncentive from './components/gatewayIncentive';
import PopularAddons from './components/popularAddons';
import {
  addAddon,
  selectPlanV2,
  removeAddon,
  applyCouponCode,
  removeCouponCode,
  showCouponResponcse,
  splitIntoFirstAndSecondName,
  openAddonsCountryPopup,
  openAddonsCountryCitiesPopup,
  openAddonsMultiLoginPopup,
  openAddonsResidentNetworkPopup,
  selectGateway,
  getSelectedGatewayOnLoad,
  removeClass,
  addPowerPack,
  removePowerPack,
  sendGa4CustomEvent,
  GA4addPaymentInfoEvent,
  resetPaymentAndIncentive,
  gmailDomainCorrection,
  openCustomModal,
  closeCustomPopup,
  getGpayOnGatewayChange,
  removeInputError,
  selectPlanByToggle,
  handleTeamQuantityBlur,
  handleTeamQuantityClick,
  getTranslation,
} from 'Generic/lib';
import planBoxes from './components/planBoxes';
import {TEAMS} from 'Generic/constants/common';
import TeamsVpnAddons from 'Generic/lib/components/teamsVpnAddons';
import {initTaxCountrySelector} from 'Generic/lib/initializers/vat';

/* Setting Global Variables */
window.base_url = window.location.origin;
window.conditionalGateways = {
  applepay: false,
  gatepay:
    (/android/i.test(navigator.userAgent) && 'gateio' in window) || //to show gatepay in android app
    (['iPad', 'iPhone'].includes(navigator?.userAgentData?.platform || navigator?.platform) &&
      typeof window.webkit?.messageHandlers?.gatepay === 'object'), //to show gatepay in iOS opp
};
window.applePay = {};
window.renderComponents = renderComponents;

/* Cart State */
let cartState = store.state.cartState ? store.state.cartState : {};

/* Parsing cart params data */
const keysToBeParsed = [
  'plans',
  'plans_currency',
  'old_prices',
  'special_addons_old_prices',
  'gateway_incentives',
  'hidden_packages_currency',
  'hidden_packages',
  'hidden_packages_currency',
  'hidden_products_association',
];
let parsedData = {};
keysToBeParsed.map(key => {
  let stateData = cartState[key];
  if (stateData) {
    parsedData = {...parsedData, [key]: JSON.parse(stateData)};
  }
});
setState(parsedData);

const {PURE_VPN} = constant;

/* Setting usefull data in variables to reuse */
const showAsSelected = cartState?.plans[0]?.labels?.show_as_selected;
const selectedPlanIndex = showAsSelected ? showAsSelected - 1 : 0;

const selectedPlan = cartState.plans[selectedPlanIndex] ? cartState.plans[selectedPlanIndex] : {};

const teamField = document.querySelector('.cart-box .team-input-number');
const dedicatedNo = document.querySelector('#dedicated-no');

// Mapping for plans by plan tpye
const mainPlanList = cartState?.plans || [];
const planTypeObj = mainPlanList.reduce((acc, item) => {
  const elemKey = (item?.plan_type_code || '').toLowerCase();
  acc[elemKey] = [...(acc[elemKey] || []), item];
  return acc;
}, {});

const planTypeArray = Object.keys(planTypeObj) || [];

const hasBFCMPromoCode = mainPlanList.filter(item => item?.pre_applied_promo_code);
const isBFCMPromoCodeActive = hasBFCMPromoCode.length > 0;

// Billing Cycle Length
const billingCycleCount = new Set((planTypeObj[planTypeArray?.[0]] || []).map(item => item.billing_cycle.replace(/ /g, '').toLowerCase())).size;

setState({
  selected_plan: selectedPlan,
  proplan_index: '0',
  teamQuantity: teamField?.value || 1,
  dedicatedIpsQuantity: 0,
  portFowardingQuantity: 0,
  conversionDriverToggle: 1,
  teamsPlanToggle: 1,
  planTypeObj,
  planTypeArray,
  billingCycleCount,
  isBFCMPromoCodeActive,
});

/* Adding selected gateway in state */
if (cartState) {
  let selectedGateway = getSelectedGatewayOnLoad();
  if (selectedGateway.gateway_key) {
    setState({
      selected_gateway: selectedGateway.gateway_key,
      selected_gateway_name: selectedGateway.gateway_name,
    });
  }
}

/* Cart gateway select event */
const gatewaysWrapper = document.querySelector('#payment_gateways');
const incentiveElement = document.querySelector('#hidden-product-wrapper');

gatewaysWrapper?.addEventListener('click', function (e) {
  let target = e.target;
  if (target.matches('.payment_selection_box, .payment_selection_box *')) {
    e.stopPropagation();

    let gatewayKey = target.getAttribute('data-name');
    let gatewayName = target.getAttribute('data-gateway-text');
    if (!gatewayKey) {
      gatewayKey = target.closest('.payment_selection_box').getAttribute('data-name');
      gatewayName = target.closest('.payment_selection_box').getAttribute('data-gateway-text');
    }
    if (incentiveElement) {
      incentiveElement.style.display = 'none';
    }

    selectGateway(gatewayKey, gatewayName);
    getGpayOnGatewayChange(gatewayKey, GatewaysInstance);
  }
});

/* Coupon Events */
const couponToggle = document.getElementById('coupon-toggle');
couponToggle.addEventListener('click', () => {
  document.querySelector('.payment-coupon-box').classList.toggle('active');
  document.querySelector('#coupon-input').focus();

  // hide coupon toggle
  couponToggle.style.display = 'none';
});

function applyCouponSubmit() {
  const couponInputValue = document.querySelector('#coupon-input').value;
  if (couponInputValue !== '') {
    if (!couponInputValue.includes('fpdr')) {
      applyCouponCode(couponInputValue);

      setTimeout(() => {
        document.querySelector('.order-sum-accordion').click();
      }, 400);
    } else {
      showCouponResponcse(false);
    }
  }

  // hide coupon toggle
  couponToggle.style.display = 'none';
}

const couponSubmitButton = document.getElementById('coupon-submit');
couponSubmitButton.addEventListener('click', function (e) {
  applyCouponSubmit();

  // hide coupon toggle
  couponToggle.style.display = 'none';
});

const couponRemoveButton = document.querySelector('.payment-coupon-cancel');
couponRemoveButton.addEventListener('click', function (e) {
  removeCouponCode();

  // hide coupon toggle
  couponToggle.style.display = 'none';
});

const couponInputField = document.querySelector('#coupon-input');
couponInputField.addEventListener('focusout', e => {
  let couponValue = e.target.value;
  if (!couponValue) removeCouponCode();
});

couponInputField.addEventListener('keypress', e => {
  if (e.which == 13) {
    e.preventDefault();
    applyCouponSubmit();
  }
});

/* Show password event */
const showPasswordButton = document.querySelector('.password-eye-icon');
showPasswordButton.addEventListener('click', () => {
  const passwordInputField = document.querySelector('#input_password');
  const type = passwordInputField.type === 'text' ? 'password' : 'text';

  passwordInputField.type = type;
});

/* Addon select event */
document.addEventListener('click', function (e) {
  let target = e.target;
  let popupCheck = false;
  let rangeClick = false;
  const planGroup = JSON.parse(cartState.selected_plan?.description || '{}').plan_group;

  if (target.matches('.vpn-teams-field-box, .vpn-teams-field-box *')) {
    e.stopPropagation();
    rangeClick = true;
  }

  /* Addon information popup button click listener */
  if (target.matches('.popup_link, .popup_link *')) {
    e.stopPropagation();
    popupCheck = true;

    let addonCode = target.getAttribute('addon-code');

    if (!addonCode) {
      addonCode = target.closest('.popup_link').getAttribute('addon-code');
    }

    let addonHttml = document.querySelector(`#${addonCode}_info_popup`);

    const modalId = `customcartPopup_${addonCode}`;

    let modalHtmlContent = addonHttml.innerHTML;

    openCustomModal(modalHtmlContent, modalId, 'modalAddonInfoClass');
  }

  if (!rangeClick) {
    /* Addon add button click listner */
    if (target.matches('.addon-btn, .addon-btn *') && !target.matches('.remove-btn, .remove-btn *, .unselect-box, .unselect-box *') && !popupCheck) {
      e.stopPropagation();
      closeCustomPopup();

      const addonBtn = target.closest('.addon-btn');
      let addonCode = target.getAttribute('addon-code');

      if (!addonCode) {
        target = target.closest('.addon-btn');
        addonCode = target.closest('.addon-btn').getAttribute('addon-code');
      }

      if (target.getAttribute('disabled') == 'disabled' || target.classList.contains('disabled-box')) return;

      if (addonCode === 'residential_network_bandwidth' && !cartState?.selected_addons?.includes(addonCode)) {
        openAddonsResidentNetworkPopup(addonCode);
        return;
      }

      if (planGroup === TEAMS) {
        addAddon(addonCode, null, false, null, planGroup);
      } else {
        if (addonCode === 'multi_login_limit' && !cartState?.selected_addons?.includes(addonCode)) {
          openAddonsMultiLoginPopup(addonCode);
          return;
        }

        if (addonCode === 'dedicated_server' && !cartState?.selected_addons?.includes(addonCode)) {
          openAddonsCountryCitiesPopup(addonCode);
          return;
        }

        if (constant.addonWithCountries.includes(addonCode) && !cartState?.selected_addons?.includes(addonCode)) {
          openAddonsCountryPopup(addonCode, () => {
            const popularAddonBox = document.querySelector('#popular-addons-box');
            const originType = addonBtn.getAttribute('data-origin');

            if (originType !== 'popular-addons' && popularAddonBox) {
              popularAddonBox?.classList.remove('active');
            }
          });
          return;
        }

        addAddon(addonCode);
      }
    }

    /* Addon remove button click listner */
    if (target.matches('.remove-btn, .remove-btn *, .unselect-box, .unselect-box *') && !popupCheck) {
      e.stopPropagation();

      let addonCode = target.getAttribute('addon-code');

      if (!addonCode) {
        addonCode = target.closest('.addon-btn').getAttribute('addon-code');
      }

      const popularAddonBox = document.querySelector('#popular-addons-box');
      if (popularAddonBox) popularAddonBox.classList.add('active');

      removeAddon(addonCode);
    }
  }

  powerPackCond();
});

(document.querySelectorAll('.faq-title') || []).forEach(element => {
  element.addEventListener('click', function () {
    if (element.classList.contains('active')) {
      element.classList.remove('active');
    } else {
      element.classList.toggle('active');
    }
  });
});

/* Pre select addon logic */
const {addons: selectedPlanAddons} = selectedPlan;
let {pre_selected_addon: preSelectedAddon} = cartState;
/*Split Pre Select addon*/
preSelectedAddon = preSelectedAddon.split(',');

for (let addon of selectedPlanAddons) {
  /* Normal addons */
  if (!constant.specialAddonList.includes(addon.code) && preSelectedAddon.includes(addon.code)) {
    /* If addon has country */
    if (constant.addonWithCountries.includes(addon.code)) {
      if (constant.addonsCountryList[addon.code]) {
        /* Generating country list HTML */
        const countries = constant.addonsCountryList[addon.code].reduce((acc, country) => {
          return acc + `<li class="icons-img ${country.code.toLowerCase()}-icon" data-country="${country.code}">${country.name}</li>`;
        }, '');

        /* appending country list HTML into country select box */
        const countryDropdownelement = document.querySelectorAll('.cart-box .dropdown-list');
        for (var i = 0; i < countryDropdownelement.length; i++) {
          countryDropdownelement[i].querySelector('.select-option-card ul').innerHTML = countries;
          countryDropdownelement[i].style.display = 'block';
          countryDropdownelement[i].setAttribute('addon-code', addon.code);
        }
      }
    } else {
      addAddon(addon.code);
    }
  }

  /* Special addons */
  if (constant.specialAddonList.includes(addon.code) && preSelectedAddon.includes(addon.code)) {
    addAddon(addon.code);
  }
}

document.addEventListener(
  'click',
  function (e) {
    const target = e.target;
    const dropdownListelement = target.closest('.dropdown-list');
    const selectedAddons = cartState.selected_addons ? cartState.selected_addons : [];

    removeClass('.dropdown-list', 'open');

    /* Addon add button click listner */
    if (target.matches('.selected-option, .selected-option *')) {
      e.stopPropagation();

      dropdownListelement.classList.add('open');
    }

    /* country click listner */
    if (target.matches('.icons-img, .icons-img *')) {
      e.stopPropagation();
      const addonCode = dropdownListelement.getAttribute('addon-code');
      const addonCountry = target.getAttribute('data-country');

      const countryDropdownelement = document.querySelectorAll('.country-select-op');
      for (var i = 0; i < countryDropdownelement.length; i++) {
        countryDropdownelement[i].innerText = target.innerText;
      }

      if (selectedAddons.includes(addonCode)) {
        removeAddon(addonCode);
      }

      addAddon(addonCode, addonCountry);
    }
  },
  true,
);

/* Special Addons select events */
document.addEventListener('click', function (e) {
  let target = e.target;
  const powerPackAddonWrapper = document.querySelector('.pro-pure-vpn-addons');
  let activePlanTab = document.querySelector('.plan-tabs-wrap li.active');
  const planType = cartState.selected_plan.description ? JSON.parse(cartState.selected_plan.description).plan_type : 'vpn_standard';
  let bundlePlanSwitcher = cartState.selected_plan.labels.enable_bundle_plan_switch;

  let activeTabName = activePlanTab?.getAttribute('data-tabs');
  if (!activeTabName) {
    activePlanTab = activePlanTab?.closest('li');
    activeTabName = activePlanTab?.getAttribute('data-tabs');
  }

  /* Special addon box click */
  if (target.matches('.special-addon-box, .special-addon-box *')) {
    e.stopPropagation();
    let checkboxelement = target.querySelector('.pcircle-checkbox');
    if (!checkboxelement) {
      target = target.closest('.special-addon-box');
      checkboxelement = target.querySelector('.pcircle-checkbox');
    }

    const addonCode = target.getAttribute('addon-code');

    if (activeTabName && bundlePlanSwitcher == '1' && planType == 'vpn_standard') {
      const selectedAddons = cartState.selected_addons ? [...cartState.selected_addons, addonCode] : [];
      const allRequiredAddonsMax = constant.specialAddonListMax.every(addon => selectedAddons.includes(addon));
      const allRequiredAddonsplus = constant.specialAddonListPlus.every(addon => selectedAddons.includes(addon));

      if (allRequiredAddonsMax) {
        if (searchAndSelectPlanV2(activeTabName, 'vpn_max')) return;
      }

      if (allRequiredAddonsplus) {
        if (searchAndSelectPlanV2(activeTabName, 'vpn_plus')) return;
      }
    }

    if (checkboxelement) {
      if (checkboxelement?.checked) {
        removeAddon(addonCode);
        target.classList.remove('active');
        checkboxelement.checked = false;
      } else {
        if (addonCode === 'multi_login_limit' && !cartState?.selected_addons?.includes(addonCode)) {
          openAddonsMultiLoginPopup(addonCode);
          return;
        }

        if (addonCode === 'dedicated_server' && !cartState?.selected_addons?.includes(addonCode)) {
          openAddonsCountryCitiesPopup(addonCode);
          return;
        }

        if (constant.addonWithCountries.includes(addonCode) && !cartState?.selected_addons?.includes(addonCode)) {
          openAddonsCountryPopup(addonCode);
          return;
        }
        addAddon(addonCode);
        target.classList.add('active');
        checkboxelement.checked = true;
      }
    }
  }

  // PowerPack Add All
  if (target.matches('.pcircle-pure-add-all, .pcircle-pure-add-all *')) {
    e.stopPropagation();
    if (target.matches('.pro-vpn-addons-add-all, .pro-vpn-addons-add-all *')) {
      const powerpackBtn = document.querySelector('#powerpack-btn');
      const added = powerpackBtn.querySelector('.add-all');
      const remove = powerpackBtn.querySelector('.remove-all');

      if (powerPackAddonWrapper.classList.contains('active')) {
        removePowerPack();
        added.style.display = 'block';
        remove.style.display = 'none';

        powerpackBtn.classList.remove('remove-pp');

        const vpnCombo = document.querySelector('.addon-vpn-combo');
        const addonVpnBox = document.querySelector('.addon-vpn-box');

        vpnCombo.classList.remove('active');
        addonVpnBox.classList.remove('active');
      } else {
        addPowerPack();
      }
    }
  }
});

/* User information input fields */
const paymentForm = document.querySelector('#payment-form');
paymentForm.addEventListener('focusout', function (e) {
  let target = e.target;
  e.stopPropagation();

  if (target.matches('#input_name,#input_email,#input_password')) {
    if (target.value) {
      const isValid = fieldsValidation(target);
      if (target.matches('#input_email') && isValid) {
        const correctDomain = gmailDomainCorrection(target.value);
        if (correctDomain) {
          target.value = correctDomain;
        }
      }
      if (window.isPaymentInfoEventSent === false && target.matches('#input_email') && isValid) {
        //send payment info event into GA4
        sendGa4CustomEvent('signup_email_push', {email: target.value});
        GA4addPaymentInfoEvent();
      }
    } else {
      removeInputError(target);
    }
  }

  if (target.matches('#input_name')) {
    const recurlyFirstNameElement = document.querySelector('[data-recurly="first_name"]');
    const recurlyLastNameElement = document.querySelector('[data-recurly="last_name"]');
    const [firstName, lastName] = splitIntoFirstAndSecondName(target.value);

    recurlyFirstNameElement.value = firstName || 'N/A';
    recurlyLastNameElement.value = lastName || 'N/A';
  }
});

// Cities Accordian
document.addEventListener(
  'click',
  function (e) {
    const target = e?.target;
    const countryListTarget = target?.closest('.country-list');
    const cityList = document?.querySelectorAll('.city-list') || [];
    const currentCity = countryListTarget?.querySelector('.city-list');
    for (var i = 0; i < cityList.length; i++) {
      cityList[i].style.display = 'none';
    }
    if (currentCity) {
      currentCity.style.display = 'block';
    }
  },
  true,
);

initTaxCountrySelector();

// Logic to handle Clicked based on scrollIntoCart
const powerPackWrapper = document.getElementById('second-step-container');
const teamsPowerPackWrapper = document.getElementById('teams-vpn-addons');
const gatewayForScroll = document.getElementById('gateway-for-scroll');

/* Render Components */
function renderComponents() {
  const OrderSummaryInstance = new OrderSummary();
  OrderSummaryInstance.render();

  const CheckoutFormInstance = new CheckoutForm();
  CheckoutFormInstance.render();

  GpayGateway.loadGooglePayIfApplicable();
  ApplePayGateway.loadApplePayIfApplicable(GatewaysInstance);
}

const GatewaysInstance = new Gateways();
GatewaysInstance.render();

/* Official Apple Pay on the Web CTA: show the branded <apple-pay-button> (hide the purple
   #submit button) only while Apple Pay is the selected gateway. Clicking it reuses #submit's
   existing flow (validation, incentives, processCheckout -> applePay.begin()). */
(function initApplePayCta() {
  const applePayCta = document.getElementById('apple-pay-cta');
  const submitBtn = document.getElementById('submit');
  if (!applePayCta || !submitBtn) return;
  applePayCta.addEventListener('click', () => submitBtn.click());
  const syncCtaVisibility = () => {
    const isApplePay = store.state.cartState?.selected_gateway === 'applepay';
    applePayCta.style.display = isApplePay ? 'inline-block' : 'none';
    submitBtn.style.display = isApplePay ? 'none' : '';
  };
  store.events.subscribe('stateChange', syncCtaVisibility);
  syncCtaVisibility();
})();

const AddonsInstance = new Addons();
AddonsInstance.render();

const packageBoxesInstance = new PackageBoxes();
packageBoxesInstance.render();

if (!!Number(cartState?.apply_powerpack)) {
  const VpnAddonsInstance = new VpnAddons();
  VpnAddonsInstance.render();
}

const TeamsVpnAddonsInstance = new TeamsVpnAddons();
TeamsVpnAddonsInstance.render();

const IncentiveInstance = new Incentive();
IncentiveInstance.render();

const GatewayIncentiveInstance = new GatewayIncentive();
GatewayIncentiveInstance.render();

const PlanBoxesInstance = new planBoxes();
PlanBoxesInstance.render();

const PopularAddonsInstance = new PopularAddons();
PopularAddonsInstance.render();

// For default plan selection on tab change
var defaultSelectedPlanType = document.querySelector('.pro-cart-container .cart-box.active-plan');

let tempSelectedAddonsIndividual = [];
let tempSelectedAddonsTeams = [PURE_VPN];

let tempDisabledAddonsIndividual = [];
let tempDisabledAddonsTeams = [];

/* Cart package boxes select event */
document.querySelectorAll('.cart-box').forEach((cartBox, index) => {
  cartBox?.addEventListener(
    'click',
    e => {
      const planCode = cartBox.getAttribute('data-plan-code');
      if (!planCode) return;

      defaultSelectedPlanType = cartBox;

      resetPaymentAndIncentive();

      let prevPlanGroup = JSON.parse(cartState.selected_plan?.description || '{}').plan_group;
      prevPlanGroup = prevPlanGroup === TEAMS ? TEAMS : 'individual';

      const proplan_index = cartBox.getAttribute('data-key');
      const newSelectedPlan = cartState.plans[index] ? cartState.plans[index] : {};

      let newPlanGroup = JSON.parse(newSelectedPlan?.description || '{}').plan_group;
      newPlanGroup = newPlanGroup === TEAMS ? TEAMS : 'individual';

      if (newSelectedPlan?.code !== cartState.selected_plan?.code) {
        const planDescription = JSON.parse(newSelectedPlan?.description || {});
        const isTeamPlan = planDescription?.plan_group === TEAMS;

        const addonsAccordionBox = document.querySelector('.addons-accordion-box');

        let selectedAddons = cartState?.selected_addons || [];
        let disableAddons = cartState?.disable_addons || [];

        // Handle showing/hiding the addons accordion
        addonsAccordionBox.classList.toggle('remove', isTeamPlan);

        // This logic is for preserved addons of teams plan and idividual plans
        if (isTeamPlan) {
          if (prevPlanGroup === 'individual') {
            tempSelectedAddonsIndividual = [...selectedAddons];
            tempDisabledAddonsIndividual = [...disableAddons];

            selectedAddons = tempSelectedAddonsTeams;
            disableAddons = tempDisabledAddonsTeams;

            if (!selectedAddons.includes(PURE_VPN)) {
              selectedAddons.push(PURE_VPN);
            }
          }
        } else if (prevPlanGroup === TEAMS) {
          tempSelectedAddonsTeams = [...selectedAddons];
          tempDisabledAddonsTeams = [...disableAddons];

          selectedAddons = tempSelectedAddonsIndividual;
          disableAddons = tempDisabledAddonsIndividual;

          selectedAddons = selectedAddons.filter(item => item !== PURE_VPN);
        }

        const data = {selectedAddons, disableAddons};

        let planIndex = index;

        if (newPlanGroup === TEAMS) {
          const {planTypeObj, planTypeArray, teamsPlanToggle, plans = []} = cartState || {};
          const teamsPlanListName = planTypeArray?.[1];
          const selectedPlan = planTypeObj?.[teamsPlanListName]?.[teamsPlanToggle];
          planIndex = plans.findIndex(plan => plan.code === selectedPlan?.code);

          toggleOrderFeatures(true);
        } else {
          toggleOrderFeatures(false);
        }

        selectPlanV2(planIndex, {proplan_index, proplan_code: null}, data);

        showHighestAddonDiscount();
      }

      showVpnStripe();

      hideTeamsMsg();
    },
    true,
  );
});

document.querySelectorAll('td.plus-border-v2').forEach(elem => {
  elem?.addEventListener('click', e => {
    const customAttributeValue = elem.getAttribute('data-key');
    const parentTable = getParentElementNode(elem, 'TABLE');
    const clickableRow = parentTable?.querySelector(`tr.top-order .cart-box[data-key="${customAttributeValue}"]`);

    const planCode = elem.getAttribute('data-plan-code');
    if (!planCode) return;

    if (clickableRow) {
      clickableRow.click();
    }

    const columnIndex = elem.cellIndex;
    const cells = document.querySelectorAll('td, th');
    cells.forEach(cell => {
      cell.classList.remove('selected');
    });

    const rows = document.querySelectorAll('tr');
    rows.forEach(row => {
      const cellsInColumn = row.cells;
      if (cellsInColumn[columnIndex]) {
        cellsInColumn[columnIndex].classList.add('selected');
      }
    });
  });
});

/* Cart Tabs */
const tabsWrapper = document.querySelector('.plan-tabs-wrap ul');
tabsWrapper?.addEventListener('click', function (e) {
  let target = e.target;

  if (target.matches('li, li *')) {
    e.stopPropagation();

    let tabName = target.getAttribute('data-tabs');
    if (!tabName) {
      target = target.closest('li');
      tabName = target.getAttribute('data-tabs');
    }

    // acordion animation
    const planboxContent = document.querySelectorAll('.planbox-content');
    planboxContent.forEach(item => {
      const nextElementSibling = item?.nextElementSibling;
      if (nextElementSibling) {
        item.classList.remove('active');
        nextElementSibling.classList.remove('accord-anim-exp');
        nextElementSibling.classList.remove('accord-anim-col');
      }
    });

    // SLiding Tabs
    slidingTab(target);

    removeClass('.plan-tabs-wrap ul li', 'active');
    target.classList.add('active');

    // tab punch line
    showTabPunchLine(tabName);

    removeClass('.plan-box-wrapper', 'active');
    const currentPlanBox = document.querySelector(`.plan-box-wrapper.${tabName}`);
    if (tabName && currentPlanBox) {
      currentPlanBox.classList.add('active');
    }

    let tabs;
    if (defaultSelectedPlanType) {
      const dataPlanType = defaultSelectedPlanType.getAttribute('data-box-code');
      tabs = document.querySelector('.plan-box-wrapper.active [data-box-code="' + dataPlanType + '"]');
    }

    if (tabs) {
      tabs.click();
    } else {
      const planIndex = target.getAttribute('data-plan-index').split(',');
      if (planIndex[0]) {
        document.querySelector(`.pro-cart-container [data-plan-index="${planIndex[0]}"]`).click();
      }
    }
  }
});

const proBtn = document.querySelectorAll('.pro-btn');
if (proBtn?.length) {
  proBtn.forEach(btn => {
    btn.addEventListener('click', () => {
      setTimeout(() => {
        const teamsCartActive = document.querySelector('.teams-addon-stripe.active');
        const scrollTarget = teamsCartActive && teamsPowerPackWrapper ? teamsPowerPackWrapper : powerPackWrapper || gatewayForScroll;

        if (scrollTarget) {
          scrollTarget.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
      }, 0);
    });
  });
}

/* Apply Coupon Link */
function searchAndSelectPlanV2(tabName, planType = null) {
  let currentPlan = null;
  //search with plan type
  if (planType) {
    currentPlan = document.querySelector(`.plan-box-wrapper.${tabName} .cart-box[data-plan-type="${planType}"]`);
  } else {
    if (!currentPlan) currentPlan = document.querySelector(`.plan-box-wrapper.${tabName} .cart-box[data-plan-type="vpn_max"]`); //select max plan
    if (!currentPlan) currentPlan = document.querySelector(`.plan-box-wrapper.${tabName} .cart-box[data-plan-type="vpn_plus"]`); //select plus plan
    if (!currentPlan) currentPlan = document.querySelector(`.plan-box-wrapper.${tabName} .cart-box[data-plan-type="vpn_standard"]`); //select standard plan
  }

  if (currentPlan) {
    const planIndex = currentPlan.getAttribute('data-key');
    const planCode = currentPlan.getAttribute('data-plan-code');

    document.querySelectorAll('[data-plan-code="' + planCode + '"]').forEach(e => e.click());

    setState({proplan_index: planIndex, proplan_code: null});
    resetPaymentAndIncentive();
    return true;
  }
  return false;
}

/* Remove Power Pack addon */
document.addEventListener('click', function (e) {
  let target = e.target;
  if (target?.matches('.vpn-addon-box, .vpn-addon-box *')) {
    e.stopPropagation();
    const btnChk = target?.closest('.addon-btn')?.querySelector('.vpn-addon-btn.icon-check');
    if (btnChk) {
      let checkBoxElem = document?.querySelector('.vpn-addon-box');
      let addonCode = target?.getAttribute('addon-code');
      if (!addonCode) {
        target = target?.closest('.addon-btn');
        addonCode = target?.closest('.addon-btn').getAttribute('addon-code');
      }
      removeAddon(addonCode);
      checkBoxElem?.classList.remove('active');

      const popularAddonBox = document.querySelector('#popular-addons-box');
      if (popularAddonBox) {
        popularAddonBox.classList.add('active');
      }
    }
  }
});

function powerPackCond() {
  const powerpackBtn = document.querySelector('#powerpack-btn');
  const added = powerpackBtn.querySelector('.add-all');
  const remove = powerpackBtn.querySelector('.remove-all');

  const powerPackCond = (cartState?.selected_addons || []).includes(constant?.PORT_FORWARDING_DEDICATED_IP);
  if (powerPackCond) {
    added.style.display = 'none';
    remove.style.display = 'block';

    powerpackBtn.classList.add('remove-pp');
  } else {
    added.style.display = 'block';
    remove.style.display = 'none';

    powerpackBtn.classList.remove('remove-pp');
  }
}

function slidingTab(elem) {
  if (elem) {
    const slideTabBox = document.querySelector('.pro-cart-wrapper li .tab-link-background');
    const tabsBox = document.querySelector('.pro-cart-wrapper .plan-tabs-wrap.currency ul');

    const tabsBoxLeft = tabsBox?.getBoundingClientRect();
    const selectedTabBox = elem?.getBoundingClientRect();
    const slideTab = slideTabBox?.getBoundingClientRect();

    let posMargin = 6;

    if (window?.innerWidth <= 768) {
      posMargin = 4;
    }

    if (selectedTabBox && slideTab) {
      const calcWidth = selectedTabBox.left - tabsBoxLeft.left - posMargin;
      slideTabBox.style.left = `${calcWidth}px`;
    }
  }
}

function showTabPunchLine(tabName) {
  const punchLineList = document.querySelectorAll('.tab-punch-line-box .punch-line');
  punchLineList.forEach(item => {
    const dataTab = item.getAttribute(`data-tabs`);
    if (dataTab === tabName) {
      item.classList.add('active');
    } else {
      item.classList.remove('active');
    }
  });
}

document.addEventListener('click', function (e) {
  const target = e.target;
  let popupCheck = false;

  /* Product information popup button click listner */
  if (target.matches('.product_popup_link, .product_popup_link *')) {
    e.stopPropagation();
    popupCheck = true;

    let productCode = target.getAttribute('product-code');

    if (!productCode) {
      productCode = target.closest('.product_popup_link').getAttribute('product-code');
    }

    const productHtml = document.querySelector(`#${productCode}_info_popup`);

    if (productHtml) {
      const modalId = `customcartPopup_${productCode}`;
      let modalHtmlContent = productHtml.innerHTML;
      let modalClass = 'modalProductInfoClass';

      let productType;
      if (productCode.startsWith('purevpn_')) {
        productType = 'purevpn';
      } else if (productCode.startsWith('purekeep_')) {
        productType = 'purekeep';
      } else if (productCode.startsWith('purecrypt_')) {
        productType = 'pureencrypt';
      } else if (productCode.startsWith('purescan_')) {
        productType = 'pureprivacy';
      }

      if (productType) {
        modalClass += ` ${productType}_product_bg`;
      }

      openCustomModal(modalHtmlContent, modalId, modalClass, '620px', false);
    }
  }

  /* Product information popup button click listner */
  if (target.matches('.bfcm_popup_link, .bfcm_popup_link *')) {
    e.stopPropagation();
    popupCheck = true;

    const productHtml = document.querySelector(`#bfcm_convserion_driver_popup`);

    if (productHtml) {
      const modalId = `convserion_driver_popup`;
      const modalHtmlContent = productHtml.innerHTML;
      const modalClass = 'modalProductInfoClass bfcm-modal-info';

      openCustomModal(modalHtmlContent, modalId, modalClass, '600px', false);
    }
  }

  if (target.matches('.product-btn, .product-btn *') && !popupCheck) {
    e.stopPropagation();
    closeCustomPopup();
  }

  /* Addon information popup button click listner */
  if (target.matches('.popup_link, .popup_link *')) {
    e.stopPropagation();
    popupCheck = true;

    let addonCode = target.getAttribute('addon-code');

    if (!addonCode) {
      addonCode = target.closest('.popup_link').getAttribute('addon-code');
    }

    let addonHttml = document.querySelector(`#${addonCode}_info_popup`);

    const modalId = `customcartPopup_${addonCode}`;

    let modalHtmlContent = addonHttml.innerHTML;

    openCustomModal(modalHtmlContent, modalId, 'modalAddonInfoClass');
  }
});

// Addons accordians
const addonsAccordionTitle = document.querySelector('.addons-accordion-title');
addonsAccordionTitle.addEventListener('click', function (e) {
  const siblingElement = addonsAccordionTitle?.nextElementSibling;

  addonsAccordionTitle.classList.toggle('active');
  siblingElement.classList.toggle('show');

  if (siblingElement.classList.contains('show')) {
    siblingElement.classList.add('addon-anim-exp');
    siblingElement.classList.remove('addon-anim-col');
  } else {
    siblingElement.classList.remove('addon-anim-exp');
    siblingElement.classList.add('addon-anim-col');
  }
});

// Teams Quantity actions
document.querySelectorAll('.team-input-btn').forEach(function (btn) {
  btn.addEventListener('click', function (event) {
    handleTeamQuantityClick(event);
  });
});

const inputTeamFieldAll = document.querySelectorAll('.team-input-number');
inputTeamFieldAll.forEach(elem => {
  elem.addEventListener('input', function (e) {
    const input = e.target;

    // Remove leading zeros
    input.value = input.value.replace(/^0+/, '');
    // Ensure the value is an integer
    input.value = input.value.replace(/\D/, '');
  });

  // Teams Quantity actions on blur
  elem.addEventListener('blur', function (e) {
    handleTeamQuantityBlur(e);
  });

  elem.addEventListener('wheel', function (e) {
    e.preventDefault();
  });

  elem.addEventListener('keydown', function (event) {
    const teamField = document.querySelector('.cart-box.active-plan .team-input-number');
    if (event.key === 'Enter') {
      teamField.blur();
    }
  });
});

// Move to Teams
const teamsTab = document.querySelector('.move-to-teams');
if (teamsTab) {
  teamsTab.addEventListener('click', function (e) {
    const moveTarget = document.querySelector('.plan-box-wrapper.active .cart-box.teams-box');

    if (moveTarget) {
      moveTarget.click();
      moveTarget.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  });
}

function showVpnStripe() {
  const selectedPlan = cartState?.selected_plan || {};
  const planDescription = JSON.parse(selectedPlan?.description || {});
  const vpnWrapper = document.querySelector('.vpn-addon-stripe');
  const teamsVpnWrapper = document.querySelector('.teams-addon-stripe');
  const PopularAddonWrapper = document.querySelector('.popular-addons-box');

  if (planDescription?.plan_group === TEAMS) {
    vpnWrapper.classList.remove('active');
    teamsVpnWrapper.classList.add('active');
    PopularAddonWrapper?.classList.remove('active');
  } else {
    vpnWrapper.classList.add('active');
    teamsVpnWrapper.classList.remove('active');
    PopularAddonWrapper?.classList.add('active');
  }
}

// Mobile Accordion JS
const overlays = document.querySelectorAll('.accordion-overlay');

const comparePlans = document.querySelectorAll('.pro-cart-wrapper .pro-cart-box-btn-wrap .faq-hdg-box');
comparePlans.forEach(item => {
  item.addEventListener('click', function (e) {
    const accCheck = item.querySelectorAll('.plan-compare-mobile-box');
    const isTeamPlan = JSON.parse(cartState?.selected_plan?.description || '{}').plan_group === TEAMS;

    if (accCheck) {
      comparePlanSetValue();
      comparePlanAccordionOpen(isTeamPlan);
    }
  });
});

overlays.forEach(overlay => {
  overlay.addEventListener('click', () => {
    const scopes = ['.pro-cart-wrapper .plan-box-wrapper.active', '.pro-cart-wrapper .teams-plan-box-wrapper'];

    scopes.forEach(selector => {
      const scope = document.querySelector(selector);
      const accordion = scope?.querySelector('.plan-compare-mobile-box');

      if (accordion?.classList.contains('active')) {
        comparePlanAccordionClose();
      }
    });
  });
});

function comparePlanAccordionOpen(isTeamPlan) {
  const accordionScope = isTeamPlan
    ? document.querySelector('.pro-cart-wrapper .teams-plan-box-wrapper')
    : document.querySelector('.pro-cart-wrapper .plan-box-wrapper.active');

  if (accordionScope) {
    const accordion = accordionScope.querySelector(isTeamPlan ? '.plan-compare-mobile-box.teams-popup' : '.plan-compare-mobile-box');

    if (accordion) {
      const content = accordionScope.querySelector('.plan-compare-mobile');
      const overlay = accordionScope.querySelector('.accordion-overlay');

      accordion.classList.add('active');

      content.style.maxHeight = '500px';
      overlay.style.visibility = 'visible';
      overlay.style.opacity = '1';
    }
  }
}

function comparePlanAccordionClose() {
  const isTeamPlan = JSON.parse(cartState?.selected_plan?.description || '{}').plan_group === TEAMS;

  const accordionScope = isTeamPlan
    ? document.querySelector('.pro-cart-wrapper .teams-plan-box-wrapper')
    : document.querySelector('.pro-cart-wrapper .plan-box-wrapper.active');

  if (accordionScope) {
    const accordion = accordionScope.querySelector(isTeamPlan ? '.plan-compare-mobile-box.teams-popup' : '.plan-compare-mobile-box');

    if (accordion) {
      const content = accordionScope.querySelector('.plan-compare-mobile');
      const overlay = accordionScope.querySelector('.accordion-overlay');

      accordion.classList.remove('active');

      content.style.maxHeight = '0';
      overlay.style.opacity = '0';
      setTimeout(() => {
        overlay.style.visibility = 'hidden';
      }, 400);
    }
  }
}

const selectedTab = document.querySelector('.pro-cart-wrapper .plan-tabs-wrap.currency ul li.active');
if (selectedTab) slidingTab(selectedTab);

let lastWindowWidth = window?.innerWidth;
let mobileViewScope = false;

window.addEventListener('resize', function () {
  const currentWindowWidth = window?.innerWidth;

  // Safty Check
  if (currentWindowWidth !== lastWindowWidth) {
    // Sliding Tabs
    const selectedTab = document.querySelector('.pro-cart-wrapper .plan-tabs-wrap.currency ul li.active');
    slidingTab(selectedTab);

    const accordionScope = document.querySelector('.pro-cart-wrapper .plan-box-wrapper.active');
    if (accordionScope) {
      const accordion = accordionScope.querySelector('.plan-compare-mobile-box');

      if (accordion) {
        const content = accordionScope.querySelector('.plan-compare-mobile');
        const overlay = accordionScope.querySelector('.accordion-overlay');

        if (window?.innerWidth >= 1200) {
          mobileViewScope = false;
        } else {
          if (!mobileViewScope) {
            accordion.classList.remove('active');
            content.style.maxHeight = '0';
            overlay.style.opacity = '0';
            overlay.style.visibility = 'hidden';

            mobileViewScope = true;
          }
        }
      }
    }

    // Update the last known window width
    lastWindowWidth = currentWindowWidth;
  }
});

function comparePlanSetValue() {
  const accordionScope = document.querySelector('.pro-cart-wrapper .plan-box-wrapper.active');
  if (!accordionScope) return;

  const selectedPlan = cartState?.selected_plan;

  // Select elements within the accordionScope once
  const planCompare = accordionScope.querySelector('.plan-compare');
  const planName = accordionScope.querySelector('.plan-name');
  const moneyBackAccord = accordionScope.querySelector('.money-back-accord');
  const planCTA = accordionScope.querySelector('.pro-cart-box-btn span');

  let buttonLabel, planLabel, moneyBackLabel;

  buttonLabel = selectedPlan?.labels?.button_label || '';
  planLabel = selectedPlan?.labels?.package_plan_label || '';
  moneyBackLabel = getTranslation(selectedPlan?.labels?.money_back_label || '');

  // Update innerHTML properties
  if (planCompare) planCompare.innerHTML = buttonLabel;
  if (planName) planName.innerHTML = planLabel;
  if (moneyBackAccord) moneyBackAccord.innerHTML = moneyBackLabel;

  const compareBtn = document.querySelector('.pro-compare-box-btn span.plan-compare');
  if (compareBtn && planCTA?.textContent) {
    compareBtn.textContent = planCTA.textContent;
  }
}

// For Single plan
const mobileAcordion = document.querySelectorAll('.pro-cart-wrapper .single_cart .pro-cart-box-btn-wrap.order-box');
mobileAcordion.forEach(item => {
  item.addEventListener('click', e => {
    const target = e.target;
    e.stopPropagation();

    const parentElem = target.closest('.planbox-content');
    const nextElementSibling = parentElem.nextElementSibling;

    parentElem.classList.toggle('active');

    if (nextElementSibling) {
      if (parentElem.classList.contains('active')) {
        nextElementSibling.classList.add('accord-anim-exp');
        nextElementSibling.classList.remove('accord-anim-col');
      } else {
        nextElementSibling.classList.add('accord-anim-col');
        nextElementSibling.classList.remove('accord-anim-exp');
      }
    }
  });
});

// Compare plans CTA event
const compareBoxCTA = document.querySelectorAll('.pro-compare-box-btn');
compareBoxCTA.forEach(item => {
  item.addEventListener('click', e => {
    e.stopPropagation();

    comparePlanAccordionClose();

    if (item.classList.contains('trigger-pop-up-v2')) return;

    setTimeout(() => {
      const teamsCartActive = document.querySelector('.teams-addon-stripe.active');
      const scrollTarget = teamsCartActive ? teamsPowerPackWrapper : powerPackWrapper;
      scrollTarget.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 0);
  });
});

function hideTeamsMsg() {
  const teamsPlan = document.querySelector('.teams-box.active-plan');
  const teamsMessage = document.querySelector('.teams-message');

  if (teamsMessage) {
    if (teamsPlan) {
      teamsMessage.classList.add('hide');
    } else {
      teamsMessage.classList.remove('hide');
    }
  }
}

// Handling the order-cycle-switch-btn click event
const orderCycleSwitchBtn = document.querySelector('.order-cycle-switch-btn');
if (orderCycleSwitchBtn) {
  orderCycleSwitchBtn.addEventListener('click', function (e) {
    e.stopPropagation();

    const {plans = []} = cartState;

    const newSelectedPlan = plans[0];

    if (newSelectedPlan) {
      const billingCycle = newSelectedPlan.billing_cycle.replace(/\s+/g, '').toLowerCase(); // Normalize billing cycle string

      // Click the corresponding tab based on billing cycle
      document.querySelector(`.plan-tabs-wrap [data-tabs="tab_${billingCycle}"]`)?.click();
    }
  });
}

const orderConversionDriverBox = document.querySelector('.order-conversion-driver-box');
const conversionDriverBtn = document.querySelector('.conversion-driver-box .conversion-btn');

if (conversionDriverBtn) {
  conversionDriverBtn.addEventListener('change', () => {
    const isChecked = conversionDriverBtn.checked;
    conversionDriverClick(isChecked);

    if (orderConversionDriverBox) {
      const {selected_plan} = cartState;
      if (JSON.parse(selected_plan?.description || '{}').plan_group !== TEAMS) {
        if (isChecked) {
          orderConversionDriverBox.classList.add('hide-it');
        } else {
          orderConversionDriverBox.classList.remove('hide-it');
        }
      }
    }
  });
}

function conversionDriverClick(check) {
  const toggleText = document.querySelector('.conversion-driver-box .text-hidden');
  const toggleTextActive = document.querySelector('.conversion-driver-box .text-hidden-v2');
  const planTabsWrap = document.querySelector('.plan-tabs-wrap');

  const isChecked = check;

  if (toggleText) {
    toggleText.classList.toggle('active', !isChecked);
    toggleTextActive.classList.toggle('active', isChecked);

    planTabsWrap.classList.toggle('bfcm-toggle-active', isChecked);

    setState({
      conversionDriverToggle: isChecked ? 1 : 0,
    });
  }
}

const teamsPlansToggle = document.querySelectorAll('.teams-toggle-box .teams-toggle-btn');
const teamsPlansToggleBox = document.querySelectorAll('.teams-toggle-box');

teamsPlansToggle.forEach(toggleButton => {
  toggleButton.addEventListener('change', () => {
    const isChecked = toggleButton.checked;
    syncToggleState(isChecked);
    toggleBtnClick(isChecked);
  });
});

function syncToggleState(isChecked) {
  // Update the state of all toggle buttons
  teamsPlansToggle.forEach(item => (item.checked = isChecked));

  // Update classes for the toggle text boxes
  teamsPlansToggleBox.forEach(item => {
    item.classList.toggle('toggle-on', isChecked);
    item.classList.toggle('toggle-off', !isChecked);
  });
}

function toggleBtnClick(check) {
  const isChecked = check;
  const selectedIndex = isChecked ? 1 : 0; //  0, 1 is using as a index of teams plans for teams plans we have only 2 plans

  const {planTypeObj, planTypeArray} = cartState || {};
  const teamsPlanListName = planTypeArray?.[1];
  const teamsPlanList = planTypeObj?.[teamsPlanListName];
  const selectedPlan = teamsPlanList[selectedIndex];

  if (selectedPlan?.code) {
    selectPlanByToggle(selectedPlan, {
      teamsPlanToggle: selectedIndex,
    });

    const teamsPlanTable = document.querySelector('.pro-cart-wrapper .teams-plan-table');
    if (teamsPlanTable) {
      teamsPlanTable.setAttribute('data-plan-code', `${selectedPlan?.code}`);
      teamsPlanTable.classList.add('active-plan');
    }
  }
}

if (orderConversionDriverBox) {
  orderConversionDriverBox.addEventListener('click', function (e) {
    e.stopPropagation();

    conversionDriverClick(true);

    orderConversionDriverBox.classList.add('hide-it');
    conversionDriverBtn.checked = true;
  });
}

function toggleOrderFeatures(shouldHide) {
  const {conversionDriverToggle} = cartState;

  const reCheckHide = conversionDriverToggle ? true : false;

  if (orderConversionDriverBox) {
    orderConversionDriverBox?.classList.toggle('hide-it', shouldHide || reCheckHide);

    if (orderConversionDriverBox.classList.contains('hide-it')) {
      orderCycleSwitchBtn?.classList.toggle('hide-it', shouldHide);
    }
  }
}

toggleOrderFeatures(true);

showVpnStripe();

observeElements('[data-gtm-event]', 0.3, gtmEventsOnScroll);

const params = new URLSearchParams(window.location.search);
const couponCode = params.get('couponcode');

if (couponCode) {
  const toggleBtn = document.getElementById('coupon-toggle');
  const inputField = document.querySelector('.payment-coupon-inpt');
  const submitBtn = document.getElementById('coupon-submit');

  if (toggleBtn) {
    toggleBtn.click();

    setTimeout(() => {
      inputField.value = couponCode;
      inputField.dispatchEvent(new Event('input', {bubbles: true}));
      submitBtn.click();
    }, 300);
  }
}

// Addons Highest Discount Percentage
const originalValue = document.querySelector('#percent_high')?.textContent;

function showHighestAddonDiscount() {
  const discountPercentage = document.querySelector('#percent_high');
  const savingLabels = document.querySelectorAll('.pvpn-saving-label');

  if (!discountPercentage || savingLabels.length === 0) return;

  let highestDiscount = 0;

  savingLabels.forEach(label => {
    const percentage = parseInt(label.textContent.replace(/\D/g, ''), 10);
    if (percentage > highestDiscount) {
      highestDiscount = percentage;
    }
  });

  discountPercentage.textContent = highestDiscount ? `${highestDiscount}%` : originalValue;
}

showHighestAddonDiscount();
